export default __webpack_public_path__ + "static/media/geoclaim.2c5b9bd6.svg";